"use server";

import { requireServerRole } from "@/lib/guards";
import {
  addShippingSiteSchema,
  editShippingSiteSchema,
  deleteShippingSiteSchema,
} from "@/lib/schemas/shipping-sites";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteShippingSite(
  params: z.infer<typeof deleteShippingSiteSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteShippingSiteSchema, params);

    await prisma.shippingSite.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addShippingSite(
  params: z.infer<typeof addShippingSiteSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { name, postalCode } = validateParams(addShippingSiteSchema, params);

    const shippingSite = await prisma.shippingSite.create({
      data: { name, postalCode, isActive: true },
    });

    return { success: true, data: shippingSite };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editShippingSite(
  params: z.infer<typeof editShippingSiteSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      name,
      postalCode,
      isActive = true,
    } = validateParams(editShippingSiteSchema, params);

    const shippingSite = await prisma.shippingSite.update({
      where: { id },
      data: { name, isActive, postalCode },
    });

    return { success: true, data: shippingSite };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
